import type { Option } from 'src/components/SelectBox';
import { WorkflowTimezone } from 'src/interfaces/workflows.interface';
import { formatWorkflowTimezone } from 'src/utils/contactWindowUtils';

export type DayOption = { value: number; label: string };

export const days: DayOption[] = [
  { value: 0, label: 'Sun' },
  { value: 1, label: 'Mon' },
  { value: 2, label: 'Tues' },
  { value: 3, label: 'Wed' },
  { value: 4, label: 'Thur' },
  { value: 5, label: 'Fri' },
  { value: 6, label: 'Sat' },
];

export const timeOptions: Option[] = Array.from({ length: 24 * 2 }).map(
  (_, i) => {
    const hour = Math.floor(i / 2);
    const minute = i % 2 === 0 ? '00' : '30';
    const ampm = hour < 12 ? 'am' : 'pm';
    const displayHour = ((hour + 11) % 12) + 1;
    const label = `${displayHour}:${minute}${ampm}`;
    const value = `${hour.toString().padStart(2, '0')}:${minute}`;
    return { label, value };
  },
);

export const timezoneOptions: Option[] = [
  {
    value: WorkflowTimezone.CONTACT_LOCAL,
    label: formatWorkflowTimezone(WorkflowTimezone.CONTACT_LOCAL),
  },
  {
    value: WorkflowTimezone.AMERICA_LOS_ANGELES,
    label: formatWorkflowTimezone(WorkflowTimezone.AMERICA_LOS_ANGELES),
  },
  {
    value: WorkflowTimezone.AMERICA_DENVER,
    label: formatWorkflowTimezone(WorkflowTimezone.AMERICA_DENVER),
  },
  {
    value: WorkflowTimezone.AMERICA_CHICAGO,
    label: formatWorkflowTimezone(WorkflowTimezone.AMERICA_CHICAGO),
  },
  {
    value: WorkflowTimezone.AMERICA_NEW_YORK,
    label: formatWorkflowTimezone(WorkflowTimezone.AMERICA_NEW_YORK),
  },
];

// The backend doesn't support contact local timezone currently. So filter it out.
export const primaryTimezoneOptions: Option[] = timezoneOptions.filter(
  (o) => o.value !== WorkflowTimezone.CONTACT_LOCAL,
);
